const permissions = {
  ALERTS: 1,
  CHATBOT: 1 << 1,
  STATISTICS: 1 << 2,
  LINKSPREE: 1 << 3,
  EXTENSIONS: 1 << 4
}

export default permissions
